/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';

export default class BannerLinkButton extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const label = this.attrs.banner.link()?.label;

		if (!label) {
			return null;
		}

		return <Button className="BannerLinkButton Button Button--primary Button--action">{m.trust(label)}</Button>;
	}
}
